package com.neurobs.js.opentok

import org.scalajs.dom.raw.HTMLElement

import scala.scalajs.js
import scala.scalajs.js.annotation.JSGlobal

@js.native
trait Event extends js.Object {
	def cancelable: Boolean = js.native
	def target: js.Object = js.native
	def `type`: String = js.native

	def isDefaultPrevented(): Boolean = js.native
	def preventDefault(): Unit = js.native
}

@js.native
trait StreamEvent extends Event {
	def stream: Stream = js.native
}

@js.native
trait StreamPropertyChangedEvent extends Event {
	// Either "hasAudio", "hasVideo", or "videoDimensions"
	def changedProperty: String = js.native
	def newValue: js.Object = js.native
	def oldValue: js.Object = js.native
	def stream: Stream = js.native
}

@js.native
trait ConnectionEvent extends Event {
	def connection: Connection = js.native
	def reason: String = js.native
}

@js.native
trait SessionConnectEvent extends Event {
	def connections: js.Array[Connection] = js.native
	def streams: js.Array[Stream] = js.native
}

@js.native
trait SessionDisconnectEvent extends Event {
	def reason: String = js.native
}

object SessionDisconnectEvent {
	val clientDisconnectedReason = "clientDisconnected"
	val forceDisconnectedReason = "forceDisconnected"
	val networkDisconnectedReason = "networkDisconnected"
}

@js.native
trait Connection extends js.Object {
	def connectionId: String = js.native
	def creationTime: Double = js.native
	def data: String = js.native
}

@js.native
trait SignalEvent extends Event {
	def data: String = js.native
	def from: Connection = js.native
}

@js.native
trait EventDispatcher extends js.Object {

}

@js.native
trait VideoDimensions extends js.Object {
	def width: Int = js.native
	def height: Int = js.native
}

@js.native
trait Stream extends js.Object {
	def connection: Connection = js.native
	def creationTime: Int = js.native
	def hasAudio: Boolean = js.native
	def hasVideo: Boolean = js.native
	def name: String = js.native
	def streamId: String = js.native
	def videoDimensions: VideoDimensions = js.native
	def videoType: String = js.native
}

@js.native
trait Subscriber extends js.Object {
	def element: HTMLElement = js.native
	def id: String = js.native
	def stream: Stream = js.native
	def getAudioVolume: Double = js.native
	def isAudioBlocked: Boolean = js.native
	def on(`type`: String, handler: js.Function1[Event, Unit]): EventDispatcher = js.native
	def off(): js.Object = js.native
	def off(`type`: String): js.Object = js.native
	def off(`type`: String, handler: js.Function1[Event, Unit]): js.Object = js.native
	def once(`type`: String, handler: js.Function1[Event, Unit]): js.Object = js.native
	def setAudioVolume(value: Double): Subscriber = js.native
	def setStyle(style: String, value: String): Subscriber = js.native
	def subscribeToAudio(value: Boolean): Subscriber = js.native
	def subscribeToVideo(value: Boolean): Subscriber = js.native
	def videoHeight: Int = js.native
	def videoWidth: Int = js.native

}

@js.native
trait Publisher extends js.Object {
	def on(`type`: String, handler: js.Function1[Event, Unit]): EventDispatcher = js.native
	def publishAudio(value: Boolean): Unit = js.native
	def publishVideo(value: Boolean): Unit = js.native
}

@js.native
trait Session extends js.Object {

	def connect(token: String, completionHandler: js.Function1[js.UndefOr[Error], Unit]): Unit = js.native

	def disconnect(): Unit = js.native

	def on(`type`: String, handler: js.Function1[Event, Unit]): EventDispatcher = js.native

	def off(`type`: String): js.Object = js.native

	def subscribe(stream: Stream, targetElement: HTMLElement, properties: js.Object, completionHandler: js.Function1[js.UndefOr[Error], Unit]): Subscriber = js.native

	def publish(publisher: Publisher, completionHandler: js.Function1[js.UndefOr[Error], Unit]): Unit = js.native

	def unpublish(publisher: Publisher): Unit = js.native

	def signal(signal: js.Object, completionHandler: js.Function1[js.UndefOr[Error], Unit]): Unit = js.native

	def connection: Connection = js.native

	def sessionId: String = js.native
}

@js.native
trait Error extends js.Object {
	def code: Int = js.native
	def message: String = js.native
	def name: String = js.native
}

@js.native
@JSGlobal
object OT extends js.Object {

	def initSession(apiKey: String, sessionId: String, options: js.Object): Session = js.native

	def initPublisher(targetElement: HTMLElement, properties: js.Object, completionHandler: js.Function1[js.UndefOr[Error],Unit]): Publisher = js.native
}
